// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__377pT","content":"styles_content__37Kjc"};